
import { Store } from "@ngxs/store";
import { IEmailHandler, EmailService, IRecipient, HarloweSupport, DraftEmail, DraftEmailInsert, EncounterDraftEmail, SentEmail} from "@harlowe/core";
import { TealHealthEncounter, TealHealthEncounterDetails} from "../../../models/encounter";
import { EncounterService } from "../../../services/encounter.service";

export class EncounterEmailHandler implements IEmailHandler
{
    emailRecipients: Map<string, IRecipient> = new Map();
    attachments: Map<string, HarloweSupport.File[]> = new Map();
    draftType?: number | undefined;

    constructor
    (
        private encounter: TealHealthEncounter | TealHealthEncounterDetails,
        private _emailService: EmailService,
        private _encounters: EncounterService,
        private _store: Store
    )
    {
        this.attachments.set("Encounter", this.encounter.attachments);
    }

    // Create Email Recipient List upon initilization
    async create(draftType?: number): Promise<EncounterEmailHandler>
    {

        return this;
    }

    async saveDraftEmail(email: DraftEmail): Promise<void> {
        if (email.id != null && email.id != -1)
            await this._emailService.updateDraftEmail(email.id, email);
        else
        {
            var encounterDraft = new EncounterDraftEmail(email.recipients, email.subject, email.body, email.from, );
            encounterDraft.encounterId = this.encounter.id;
            await this._encounters.addEncounterDraftEmail(this.encounter.id, encounterDraft);
        }
    }

    async sendEmail(draftEmail: DraftEmail): Promise<SentEmail | undefined>
    {
        if(this.encounter && draftEmail)
        {
            var draftInsert = new DraftEmailInsert
            (
                draftEmail.subject,
                draftEmail.recipients,
                draftEmail.body,
                draftEmail.ccs,
                draftEmail.bccs,
                draftEmail.from,
                draftEmail.attachmentIds
            )
            return await this._encounters.sendNewEmail(this.encounter.id,draftInsert) as SentEmail;
        }
        return;
    }

    getRelatedObject(): TealHealthEncounter {
        return this.encounter;
    }

}


